// App header with logo and navigation

import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function Header() {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <header className="sticky top-0 flex items-center justify-between px-4 py-3 bg-gray-900 border-b border-gray-800 z-50">
      <Link to="/" className="flex items-center gap-2">
        <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
          <span className="text-white text-sm font-bold">P</span>
        </div>
        <span className="font-semibold text-lg">PhillyWatch</span>
      </Link>

      <nav className="flex items-center gap-2">
        <button
          onClick={() => navigate('/feed')}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            location.pathname === '/feed'
              ? 'bg-red-500 text-white'
              : 'text-gray-400 hover:text-white hover:bg-gray-800'
          }`}
        >
          Feed
        </button>
      </nav>
    </header>
  )
}
